export const CAMPSITESCOMMENTS = [
    {
        id: 0,
        campsiteId: 0,
        text: 'It was an amazing trip!'
    },
    {
        id: 1,
        campsiteId: 0,
        text: 'Even better the second time!'
    },
    {
        id: 2,
        campsiteId: 1,
        text: 'Love it here!'
    },
    {
        id: 3,
        campsiteId: 1,
        text: 'Its all washed out now...'
    },
    {
        id: 4,
        campsiteId: 2,
        text: 'So glad i found this spot!'
    },
    {
        id: 5,
        campsiteId: 2,
        text: 'They made some great improvements!'
    },
]